<template>
  <v-card class="login-card" elevation="0">
    <div class="login-header">
      <div class="header-row">
        <div class="header-icon"><v-icon color="white" size="18">mdi-login-variant</v-icon></div>
        <span class="header-title">{{ $t('pages.login_activity') }}</span>
      </div>
    </div>
    <v-card-text class="pa-3 pa-sm-4">
      <div class="period-tabs">
        <button v-for="p in periods" :key="p.key" class="period-btn" :class="{ active: activePeriod === p.key }" @click="activePeriod = p.key">
          {{ p.label }}
        </button>
      </div>
      <div class="login-rows">
        <div v-for="item in rows" :key="item.role" class="login-row">
          <div class="login-row-icon" :style="{ background: item.color + '18' }">
            <v-icon :color="item.color" size="18">{{ item.icon }}</v-icon>
          </div>
          <div class="login-row-label">{{ item.label }}</div>
          <div class="login-row-bar-wrap">
            <div class="login-row-bar" :style="{ width: maxVal > 0 ? (getVal(item) / maxVal * 100) + '%' : '0%', background: item.color }"></div>
          </div>
          <div class="login-row-count" :style="{ color: item.color }">
            <span v-if="loading">—</span>
            <span v-else>{{ getVal(item) }}</span>
          </div>
          <div class="login-row-last" v-if="item.lastLogin">
            <v-icon size="11" color="grey">mdi-clock-outline</v-icon>
            <span>{{ formatLast(item.lastLogin) }}</span>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    loginActivity: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      activePeriod: 'today',
      periods: [
        { key: 'today', label: 'Sot' },
        { key: 'week',  label: '7 ditë' },
        { key: 'month', label: '30 ditë' },
      ],
    }
  },
  computed: {
    rows() {
      return [
        { role: 'organizations', label: 'Organizata',        icon: 'mdi-school',                 color: '#1976D2', lastLogin: this.loginActivity.organizations?.last },
        { role: 'parents',       label: 'Prindër/Kujdes.',   icon: 'mdi-account-group-outline',   color: '#7B1FA2', lastLogin: this.loginActivity.parents?.last },
        { role: 'students',      label: 'Nxënës',            icon: 'mdi-badge-account-outline',   color: '#F57C00', lastLogin: this.loginActivity.students?.last },
        { role: 'drivers',       label: 'Shoferë',           icon: 'mdi-account-tie-hat-outline', color: '#388E3C', lastLogin: this.loginActivity.drivers?.last },
        { role: 'directors',     label: 'Drejtorë',          icon: 'mdi-account-star-outline',    color: '#e65100', lastLogin: this.loginActivity.directors?.last },
      ]
    },
    maxVal() {
      return Math.max(1, ...this.rows.map(r => this.getVal(r)))
    },
  },
  methods: {
    getVal(item) {
      return this.loginActivity[item.role]?.[this.activePeriod] ?? 0
    },
    formatLast(dt) {
      if (!dt) return ''
      const d = new Date(dt)
      const now = new Date()
      const diff = Math.floor((now - d) / 60000)
      if (diff < 1) return 'tani'
      if (diff < 60) return diff + 'min'
      if (diff < 1440) return Math.floor(diff/60) + 'orë'
      return Math.floor(diff/1440) + 'ditë'
    },
  },
}
</script>

<style scoped>
.login-card { border-radius: 14px !important; border: 1px solid rgba(0,0,0,0.06) !important; overflow: hidden; height: 100%; }
.login-header { background: linear-gradient(90deg, #2E7D32, #388E3C); padding: 14px 20px; }
.header-row { display: flex; align-items: center; gap: 10px; }
.header-icon { width: 28px; height: 28px; background: rgba(255,255,255,0.2); border-radius: 8px; display: flex; align-items: center; justify-content: center; }
.header-title { color: #fff; font-size: 14px; font-weight: 700; letter-spacing: 0.3px; }
.period-tabs { display: flex; gap: 6px; margin-bottom: 14px; flex-wrap: wrap; }
.period-btn { padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; border: 1.5px solid rgba(0,0,0,0.12); background: transparent; cursor: pointer; color: #64748b; transition: all 0.15s; }
.period-btn.active { background: #388E3C; color: #fff; border-color: #388E3C; }
.login-rows { display: flex; flex-direction: column; gap: 8px; }
.login-row { display: flex; align-items: center; gap: 8px; padding: 6px 0; border-bottom: 1px solid rgba(0,0,0,0.04); }
.login-row:last-child { border-bottom: none; }
.login-row-icon { width: 32px; height: 32px; border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
.login-row-label { width: 110px; font-size: 11px; font-weight: 600; color: #475569; flex-shrink: 0; }
.login-row-bar-wrap { flex: 1; height: 6px; background: rgba(0,0,0,0.06); border-radius: 99px; overflow: hidden; min-width: 30px; }
.login-row-bar { height: 100%; border-radius: 99px; transition: width 0.4s ease; }
.login-row-count { width: 28px; text-align: right; font-size: 14px; font-weight: 800; flex-shrink: 0; }
.login-row-last { font-size: 10px; color: #94a3b8; flex-shrink: 0; display: flex; align-items: center; gap: 2px; min-width: 36px; }

@media (max-width: 480px) {
  .login-row-label { width: 80px; font-size: 10px; }
  .login-row-last { display: none; }
  .login-row-count { font-size: 13px; }
}
</style>
